import { get, post, put, patch, webApi, _saveToken } from '../utils/http';
import queryString from 'query-string';
import store from '../store';
import { revokeNawiSession } from '../persons/components/NawiChat/nawiChatApi';

export const services = {
  refreshToken: (token) => post(webApi + `auth/refresh/`, { token }),
  login: (body) =>
    post(webApi + 'api/auth/login', body).then((data) => {
      if (data?.token) _saveToken(data.token);
      return data;
    }),
  baproLogin: (body) =>
    post(webApi + 'api/auth/bapro', body).then((data) => {
      _saveToken(data.token);
      return data;
    }),
  googleLogin: (body) =>
    post(webApi + 'api/auth/google/bapro', body).then((data) => {
      _saveToken(data.token);
      return data;
    }),
  getPartner: (id) => get(webApi + `api/companies/company`),
  logout: () => {
    // Best-effort: revoke the NAWI session while the token is still available.
    // This runs for every logout (all UI paths dispatch session.logout, which
    // the session middleware turns into this call) and must never block it.
    try {
      Promise.resolve(
        revokeNawiSession(store.store.getState().session.user),
      ).catch(() => {});
    } catch (_error) {
      // Ignored on purpose.
    }
    delete localStorage['token'];
    delete localStorage['token-ts'];
    delete localStorage['nawaiam_chat_history'];
  },
  getUsers: () =>
    get(webApi + `api/users/?lang=${localStorage.getItem('language')}`),
  activateToken: (token) => put(webApi + `api/users/activation/${token}/`),
  recoverPassword: (email) =>
    post(webApi + `api/auth/recovery`, {
      email,
      lang: localStorage.getItem('language'),
    }),
  resetPassword: (body) => patch(webApi + `api/auth/recovery`, body),
  validateTokenChangePassword: (data) =>
    get(
      webApi +
        `api/auth/recovery?${queryString.stringify({ token: data.token })}`,
    ),
  verifyMfa: (body) =>
    post(webApi + 'api/auth/mfa/verify', body).then((data) => {
      if (data?.token) _saveToken(data.token);
      return data;
    }),
  resendMfa: (body) => post(webApi + 'api/auth/mfa/resend', body),

};
